<template>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
         x="0px" y="0px"
         viewBox="0 0 16 14"
         xml:space="preserve"
         :style="`fill: ${iconColor};`"
         :width="width"
         :height="height">
<path d="M4,1c0.6,0,1,0.4,1,1v10c0,0.6-0.4,1-1,1H2c-0.6,0-1-0.4-1-1V2c0-0.6,0.4-1,1-1H4 M4,0H2C0.9,0,0,0.9,0,2v10
	c0,1.1,0.9,2,2,2h2c1.1,0,2-0.9,2-2V2C6,0.9,5.1,0,4,0z M16,2.5C16,2.2,15.8,2,15.5,2c0,0,0,0,0,0h-7C8.2,2,8,2.2,8,2.5S8.2,3,8.5,3
	h7C15.8,3,16,2.8,16,2.5C16,2.5,16,2.5,16,2.5z M16,5.5C16,5.2,15.8,5,15.5,5c0,0,0,0,0,0h-7C8.2,5,8,5.2,8,5.5S8.2,6,8.5,6h7
	C15.8,6,16,5.8,16,5.5C16,5.5,16,5.5,16,5.5z M16,8.5C16,8.2,15.8,8,15.5,8c0,0,0,0,0,0h-7C8.2,8,8,8.2,8,8.5S8.2,9,8.5,9h7
	C15.8,9,16,8.8,16,8.5C16,8.5,16,8.5,16,8.5z M16,11.5c0-0.3-0.2-0.5-0.5-0.5c0,0,0,0,0,0h-7C8.2,11,8,11.2,8,11.5S8.2,12,8.5,12h7
	C15.8,12,16,11.8,16,11.5C16,11.5,16,11.5,16,11.5z"/>
</svg>
</template>

<script>
    export default {
        name: "ViennaClassesIcon",
        props: {
            width: {
                type: [Number, String],
                default: 18
            },
            height: {
                type: [Number, String],
                default: 18
            },
            iconColor: {
                type: String,
                default: '#211f20'
            }
        }
    }
</script>

<style scoped>

</style>
